import Typography from "@material-ui/core/Typography";
import React from "react";

export function Code({code, title}) {
  return (<>
    <Typography variant="subtitle2" display="inline">{code} </Typography>
    <Typography display="inline">{title}</Typography>
  </>);
}